class SiteFooter extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.querySelectorAll('.footer__links__block__title').forEach((title) =>
            title.addEventListener('click', this.openMenu.bind(this))
        );
    }

    openMenu() {
        const thisButton = event.currentTarget;
        const nextElement = thisButton.nextElementSibling;

        thisButton.classList.toggle('active-menu');
        nextElement.classList.toggle('open-menu');
    }
}

customElements.define('site-footer', SiteFooter);